import { ProductGoToActionBlock } from "../../products";
import { GetMoreContactsForAccountBtn } from "../../ui/GetMoreContactsForAccountBtn";
import { CampaignDetailsResponse } from "../../../types/apiTypes";

export const GetContactsForCompanyBlock = ({
  account_id,
  account,
}: {
  account_id: string;
  account: CampaignDetailsResponse;
}) => {
  return (
    <ProductGoToActionBlock
      title="No Contacts Available"
      texts={[
        `Gain buying committee insights for ${account.output.company.name} by running an up-to-date
         contact search.`,
      ]}
      btn={<GetMoreContactsForAccountBtn account_id={account_id} />}
    />
  );
};
